import React from 'react';
export default class AdHocExportItem {
  constructor(item) {
    if (item === undefined) {
      this.AllOffice = [];
      this.Offices = [];
      this.ExportType = 2; // Ad Hoc Export
    } else {
      this.AllOffice = [];
      this.Offices = item.offices;
      this.ExportType = 2; // Ad Hoc Export
    }
    this.Notes = (
      <span>
        Please select the offices for this Ad Hoc payment export, then click on the start button.
        <br />
        <br />
        The payment export will start within an hour.
      </span>
    );
  }
}
